import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { toParams } from 'libs/utils/url';
const EVENT_TRACKER_PLATFORM = 'web';
const EVENT_TRACKER_ID = 'v4';

const buildEvent = (event, context) => ({
  event: event.event,
  anon_id: context.anonId,
  user_id: event.userId || context.userId,
  lang_code: context.languageCode,
  extra: _objectSpread({
    screen: context.screen.name,
    path: window.location.pathname,
    utm_campaign: context.utm.campaign,
    utm_source: context.utm.source,
    utm_medium: context.utm.medium,
    utm_content: context.utm.content
  }, event.extra),
  time: Date.now()
});

const buildRequestHeaders = context => {
  const headers = {
    'X-Portal': context.portal,
    'X-Platform': context.platform || EVENT_TRACKER_PLATFORM,
    'X-Debug-Info': EVENT_TRACKER_ID,
    'X-Local-Time': Date.now(),
    'X-Screen-Width': context.screen.width,
    'X-Screen-Height': context.screen.height
  };
  if (context.debugPin) headers['X-Debug-Pin'] = context.debugPin;
  return headers;
};

const utmParams = ['utm_campaign', 'utm_source', 'utm_medium', 'utm_content'];

const getScreenUtmParams = () => {
  const queryParams = toParams(window.location.search);
  return utmParams.reduce((accumulator, key) => {
    const param = queryParams[key];
    if (param && typeof param === 'string') accumulator[key] = param;
    return accumulator;
  }, {});
};

export { buildEvent, buildRequestHeaders, getScreenUtmParams };